import { useQuery } from '@tanstack/react-query';
import { useApi } from 'common/hooks/api';

export function useAgencyPortalStatus(agencyId) {
  const Api = useApi();
  const query = useQuery({
    queryKey: ['agencyPortalStatus', agencyId],
    queryFn: async () => {
      if (!agencyId) return {};
      const response = await Api.userInfoByAgency(agencyId);
      return response?.data || {};
    },
    enabled: !!agencyId,
    retry: false,
    staleTime: 6000,
    cacheTime: 6000,
  });
  return query;
}
